import { constants as firebaseConstants } from "react-redux-firebase"
import { constants } from '../constants/global.constants';

export function projectReducer(state = { selectedProjectId: null, selectedSchedule: null, selectedScheduleId: null, projectLoading: false, selectedProject: null, _Counter: 0, selectProjectCounter: 0, reportDays: [] }, action) {
    /*state = Object.assign({}, state, {
        _Counter: state._Counter+=1
    })

    if (action.type === '@@reactReduxFirebase/SET_PROFILE') {
        state = Object.assign({}, state, {
            selectProjectCounter: state.selectProjectCounter += 1
        })
    }*/

    switch (action.type) {
        case firebaseConstants.actionTypes.START: {

            if (action.path === 'SELECTED_PROJECT') {
                return Object.assign({}, state, {
                    projectLoading: true
                })
            }

            return state
        }

        case firebaseConstants.actionTypes.SET_PROFILE: {
            const { profile } = action
            if(!profile) {
                return undefined
            }
            if (!!profile && !!profile.projects && Object.keys(profile.projects).length > 0) {
                const oldProjectId = state.selectedProjectId
                const projectId = Object.keys(profile.projects)[0];

                if(!!oldProjectId && !!profile.projects[oldProjectId]) {
                    return Object.assign({}, state, {
                        selectedProjectId: oldProjectId
                    })
                } else {
                    return Object.assign({}, state, {
                        selectedProjectId: projectId
                    })
                }
                
            }
            return state
    }

        case firebaseConstants.actionTypes.SET: {
            if (action.path == 'SELECTED_PROJECT') {
                if(!action.data) return state
                
                const selectedScheduleId = !!state.selectedScheduleId ? state.selectedScheduleId : 'master_schedule_id'

                return Object.assign({}, state, {
                    projectLoading: false,
                    selectedProject: action.data,
                    selectedScheduleId: selectedScheduleId
                })
            }

            if(action.path == 'REPORT_SETTINGS') {
                if(!action.data) {
                    return {
                        ...state
                    }
                }
                const { reportDays } = action.data

                const days = !!reportDays ? reportDays : []

                return {
                    ...state,
                    reportDays: days
                } 
            }

            return state
        }
        case constants.SELECT_PROJECT: {
            return Object.assign({}, state, {
                selectedProjectId: action.selectedProjectId
            })
            break;
        }
        
        case constants.SELECT_SCHEDULE: {
            const { selectedProject } = state
            const { scheduleId } = action

            if(!selectedProject) return state

            const schedule = selectedProject.schedules[scheduleId]

            if(!schedule) return state


            return Object.assign({}, state, {
                selectedScheduleId: action.scheduleId,
                selectedSchedule: schedule
            })
        }

        case firebaseConstants.actionTypes.NO_VALUE: {

            if (action.path === 'SELECTED_PROJECT') {
                return Object.assign({}, state, {
                    projectLoading: false
                })
            }

            return state
        }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/modules/project.reducer.js